function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'onyxschwarz': 'rgb(0, 0, 0)','konigsblau': 'rgb(36, 53, 87)','kristallweiss': '','granitgrau': 'rgb(190, 190, 190)','tonkabraun': 'rgb(200, 175, 145)','schwarz': 'rgb(23, 23, 23)','black': 'rgb(23, 23, 23)','blau': 'rgb(36, 53, 87)','blue': 'rgb(36, 53, 87)','braun': 'rgb(118, 87, 71)','brown': 'rgb(118, 87, 71)','grau': 'rgb(136, 136, 136)','grey': 'rgb(136, 136, 136)','gray': 'rgb(136, 136, 136)','greige': 'rgb(169, 159, 145)','anthrazit': 'rgb(60, 61, 63)','anthracite': 'rgb(60, 61, 63)','charcoal': 'rgb(60, 61, 63)','burgunderrot': 'rgb(110, 32, 53)','burgundy': 'rgb(110, 32, 53)',};

    this.images = {'echtleder-blau': 'url("//dug-glashuette.com/cdn/shop/files/blue_68x.png?v=13858236273993497400")','metallband': 'url("//dug-glashuette.com/cdn/shop/files/metall_68x.png?v=674293505940573812")','echtleder-schwarz': 'url("//dug-glashuette.com/cdn/shop/files/black_68x.png?v=16406586269063699596")',};

    this.triggers = ['zifferblatt','armband','farbe','color','colour',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

window.theme.swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  window.theme.swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

